// スムーススクロール
$(function(){
  $('a[href^="#"]').click(function(){
    let speed = 500;
    let href= $(this).attr("href");
    let target = $(href == "#" || href == "" ? 'html' : href);
    let position = target.offset().top;
    $("html, body").animate({scrollTop:position}, speed, "swing");
    return false;
  });
});


//ページトップへ戻るボタン
$(function(){
  $(window).on('load scroll', function(){
    if ($(window).scrollTop() > 500) {
      $('#toPageTop').fadeIn(500);
      } else {
      $('#toPageTop').fadeOut(500);
      }
  });
});


//SPメニュー
$(function(){
  var state = false;
  var pos;
  $('.nav_btn').click(function(){
    if (state == false) {
      pos = $(window).scrollTop();
      $('body').addClass('fixed').css({'top': -pos});
      
      $('#nav_wrapper').addClass('open');
      state = true;
    } else {
      $('#nav_wrapper').removeClass('open')
      $('body').removeClass('fixed').css({'top': 0});

      window.scrollTo(0, pos);
      state = false;
    }
  });
  $('.sp_header a , .bg').click(function(){
      $('#nav_wrapper').removeClass('open');
      $('body').removeClass('fixed').css({'top': 0});

      window.scrollTo(0, pos);
      state = false;
  });
});


// スクロールしたらSPメニュー表示
$(function(){
  $(window).on('load scroll', function(){
    if ($(window).scrollTop() > 500) {
    $('.fixed_header').fadeIn(500);
    } else {
    $('.fixed_header').fadeOut(500);
    }
  });
});



// アニメーショ（フェードイン）
window.addEventListener("scroll", function () {
  const elements = document.getElementsByClassName("fadeInUp");

  Array.prototype.forEach.call(elements, function (element) {
    const elementTop = element.getBoundingClientRect().top;
    const windowHeight = window.innerHeight;

    //コンテンツが現れてから300pxしたらclassを付与
    if (elementTop - windowHeight + 300 <= 0) {
      element.classList.add("animated");
    }
  });
});